var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.selection)?_c('b-row',{staticClass:"preview-center",attrs:{"no-gutters":""}},[_c('b-col',[_c('span',{staticClass:"text-danger-light pointer",on:{"click":function($event){return _vm.$emit('on:minus-icon-click')}}},[_c('i',{staticClass:"fa custom-icon-size fa-minus"})])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }